import React from 'react'
import {Query} from 'react-apollo'

import catalogTypes from '../Root/catalog-types'
import CatalogPageWithMutation from './mutation'
import Error from '../../base/Error'
import Loading from '../../base/Loading'
import categoriesByCatalogTypes from './categories-by-catalog-types.graphql'


const catalogTypeNames = Object.values(catalogTypes).map(type => type.name)

const CatalogPageWithData = ({activeCatalogType, activeCategoryId, ...otherProps}) => <Query
  query={categoriesByCatalogTypes}
  variables={{catalogTypeNames}}
>
  {({loading, error, data}) => {
    if (loading) return <Loading/>
    if (error) return <Error/>

    const categoriesByCatalogTypeNames = data.categoriesByCatalogTypes.reduce(
      (result, item) => ({ ...result, [item.catalogTypeName]: item.categories }),
      {}
    )

    const activeCategory = categoriesByCatalogTypeNames[activeCatalogType.name].find(category => category.id === activeCategoryId)

    return <CatalogPageWithMutation {...otherProps}
      activeCatalogType={activeCatalogType}
      activeCategory={activeCategory}
      categoriesByCatalogTypeNames={categoriesByCatalogTypeNames}
    />
  }}
</Query>

export default CatalogPageWithData
